import { NavLink as RouterLink, useLocation } from 'react-router-dom'
import Btn from '../components/Btn'

import { Box, InputLabel, Link, TextField } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'

import logo from '../assets/images/logo-lg.svg'
import { useState, useEffect } from 'react'
import { useLoginMutation } from '../redux/api/authApi'
import { PATH, PATH_LOGIN } from '../routes/constant'
import useToken from '../hooks/useToken'
import ErrorMessage from '../components/ErrorMessage'
import AlertNotification from '../components/AlertNotification/AlertNotification'

const Label = styled(InputLabel)(({ theme }) => ({
  color: '#6B7A99',
  fontSize: 14,
  fontWeight: 700,
  marginBottom: '13px'
}))

const LoginPage: React.FC = () => {
  const theme = useTheme()
  const [user, setUser] = useState<string>('')
  const location = useLocation()
  const [pwd, setPwd] = useState<string>('')
  const [login, {
    isLoading,
    isError,
    isSuccess,
    error
  }] = useLoginMutation()
  const { xsrf } = useToken()

  const handleSubmit = async (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    await login({
      email: user,
      password: pwd,
      token: xsrf
    })
  }

  const handleSubmitByEnter = async (e: any) => {
    if (e.keyCode === 13) {
      e.preventDefault()
      await login({
        email: user,
        password: pwd,
        token: xsrf
      })
    }
  }

  useEffect(() => {
    if (isSuccess && !location.state?.prev) {
      window.location.href = PATH.HOME
    }

    if (isSuccess && location.state?.prev) {
      window.location.href = location.state?.prev
    }
  }, [isLoading, location])

  return (
        <Box>
            {location.state?.isPasswordChange && <AlertNotification text="Password updated successfully" />}
            {location.state?.isEmailChange && <AlertNotification text="Email updated successfully" />}
            {location.state?.isSessionOver && <AlertNotification text="Session is over, please re-login to your account" />}
            <Box
                component='img'
                src={logo}
                sx={{
                  height: '70px',
                  margin: '0 auto 50px',
                  width: '189px'
                }}
            />
            <Box
                component="form"
            >
                <Box sx={{
                  display: 'flex',
                  gap: '24px',
                  flexDirection: 'column',
                  mb: '29px'
                }}>
                    <Box>
                        <Label htmlFor='email'>Email</Label>
                        <TextField
                            onKeyDown={handleSubmitByEnter}
                            error={isError}
                            aria-invalid={isError}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                              setUser(e.target.value)
                            }}
                            value={user}
                            type='text'
                            id='email'
                            fullWidth
                        />
                    </Box>
                    <Box>
                        <Label htmlFor='password' sx={{
                          alignItems: 'center',
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}>
                            Password
                            <Link
                                component={RouterLink} to={PATH_LOGIN.PASSWORD_RESET}
                                underline="none"
                                sx={{
                                  color: theme.palette.secondary.main
                                }}
                            >Forgot Your Password?</Link>
                        </Label>
                        <TextField
                            onKeyDown={handleSubmitByEnter}
                            error={isError}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                              setPwd(e.target.value)
                            }}
                            aria-invalid={isError}
                            value={pwd}
                            type='password'
                            id='password'
                            fullWidth
                        />
                    </Box>
                </Box>
                <Btn disabled={isLoading} onClick={handleSubmit} variant='contained' color='secondary' text='Login' type='submit' sx={{
                  cursor: 'pointer',
                  fontSize: '14px',
                  p: '18px 0 ',
                  width: '100%'
                }}/>
            </Box>
            <ErrorMessage error={error} />
        </Box>
  )
}

export default LoginPage
